module.exports = __webpack_public_path__ + "img/2-m.29274a8a.jpg";